import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { App, NavController, NavParams } from 'ionic-angular';
import { Storage } from '../../../node_modules/@ionic/storage';
import { TranslateService } from '../../../node_modules/@ngx-translate/core';
import { AuthenticationService } from '../../providers/authentication/authenticationService';
import { Config } from '../../providers/config';
import { ConfigService } from '../../providers/config/config.service';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  error = null;
  private currentConfiguration: Config;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private backendService: PaytronBackendService,
    private authenticationService: AuthenticationService,
    public translate: TranslateService,
    private storage: Storage,
    private configService: ConfigService,
    private app: App
  ) {
    this.translate.setDefaultLang('it');
    this.translate.use(this.translate.getBrowserLang());
    this.storage.set('lang', this.translate.getBrowserLang());
    this.currentConfiguration = this.configService.getConfiguration();
    if (this.navParams.get('isSessionTimeout')) {
      this.error = 'isSessionTimeout';
    }
  }

  login(loginForm: NgForm) {
    this.authenticationService.login(loginForm.value.username, loginForm.value.password).subscribe(
      (response) => {
        let authority = response && response.user && response.user.authorities[0];
        this.storage.set('userRole', authority).then(() => {
          let navControllerService: NavControllerService = new NavControllerService(this.app, this.storage);
          switch (authority) {
            case 'ROLE_INSTALLATORE':
              navControllerService.showPosPage();
              break;
            case 'ROLE_SETUP':
            case 'ROLE_TESORIERE':
              navControllerService.showUsersPage();
              break;
            case 'ROLE_RICEVIMENTO':
            case 'ROLE_ADMIN':
              navControllerService.showCustomersPage();
              break;
            default:
              navControllerService.showLoginPage();
              break;
          }
        });
        ;
      },
      (err: HttpErrorResponse) => {
        if (err.status == 401) {
          ;
          this.error = 401;
        }
        if (err.status == 0) {
          ;
          this.error = 0;
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts